import { render } from "./HelloView.vue?vue&type=template&id=975959ae&scoped=true"
import script from "./HelloView.vue?vue&type=script&lang=js"
export * from "./HelloView.vue?vue&type=script&lang=js"

import "./HelloView.vue?vue&type=style&index=0&id=975959ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975959ae"]])

export default __exports__